import React, { Component } from 'react';
import { inject, observer } from "mobx-react";
import {Request, VarHelper} from "common-import/helpers";

@inject("userStore", "masterStore", "membershipStore") @observer
export default class MemberShip extends Component {
  constructor() {
    super();
    this.state = {
      active: 'owner',
    }
  }
  componentDidMount = async () => {
    await this.props.userStore.onReady();
    await this.props.masterStore.onReady();
  };
  getListPricing = (e, type) => {
    !!e && e.preventDefault();
    this.setState({ active: type });
  };
  renderPricing = () => {
    const { active } = this.state;
    const {
      toValue,
      Account_Membership,
    } = this.props.masterStore;

    const getMemList = () => {
      let pkg = [];
      let fts = [];
      let from = 0, to = 0;
      if (active === 'contractor') {
        from = 1; to = 4;
      } else if (active === 'supplier') {
        from = 5; to = 8;
      } else if (active === 'owner') {
        from = 9; to = 12;
      }
      for (let i = from; i <= to; i++) {
        pkg = [...pkg, toValue(Account_Membership, i)];
        fts = [...fts, toValue(Account_Membership, i + 0.1)];
      }
      return { pkg, fts };
    };

    const renderDetail = ({ pkg = [], fts = [] }) => {
      return pkg.map((item, index) => {
        return (
          <div key={'pricing'+index} className="card mb-3 shadow-sm card-pricing">
            <div className="card-header">
              <h4 className="my-0 font-weight-normal">{typeof item === "string" ? item.split(':')[0] : ''}</h4>
            </div>
            <div className="card-body">
              <h1 className="card-title pricing-card-title">{typeof item === "string" ? item.split(':')[1] : ''}
                <small className="text-muted"> </small>
              </h1>
              <ul className="text-left mt-3 mb-4">
                {typeof fts[index] === "string" ? fts[index].split('(-)').slice(1).map((itm, idx) => <li key={'feature'+idx}> {itm}</li>) : ''}
              </ul>
            </div>
          </div>
        )
      })
    };

    return (
      <section>
        <div className="pricing-header px-3 py-3 pt-md-4 pb-md-5 mx-auto text-center">
          <div className="btn-group" role="group" aria-label="Basic example">
            <button onClick={e => this.getListPricing(e, 'owner')} type="button" className={active === 'owner' ? 'btn btn-primary':'btn btn-outline-primary'}>Owner</button>
            <button onClick={e => this.getListPricing(e, 'supplier')} type="button" className={active === 'supplier' ? 'btn btn-primary':'btn btn-outline-primary'}>Supplier</button>
            <button onClick={e => this.getListPricing(e, 'contractor')} type="button" className={active === 'contractor' ? 'btn btn-primary':'btn btn-outline-primary'}>Contractor</button>
          </div>
        </div>
        <div className="card-deck mb-3 text-center">
          {renderDetail(getMemList())}
        </div>
      </section>
    );
  };
  render() {
    return (
      <div className="animated fadeIn">
        {this.renderPricing()}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/views/Master/MemberShip.js